@if (linkType === 'href') {
  <a id="{{linkId}}" href="{{linkUrl}}" title="{{linkTitle}}" [target]="linkTarget" class="btn btn-{{linkStyle}} {{linkClass}}">
    @if (linkTitle && !matIcon) {
      <div class="d-flex align-items-center justify-content-center h-100" [innerHTML]="linkTitle"></div>
    }
    @if (!linkTitle && matIcon) {
      <div class="d-flex align-items-center justify-content-center h-100">
        <span class="material-symbols-outline mat-icon-size-{{matIconSize}}" [ngClass]="{'filled': matIconFilled}">{{matIcon}}</span>
      </div>
    }
    @if (linkTitle && matIcon) {
      <div class="d-flex align-items-center justify-content-center h-100">
        <span class="{{matIconPosition === 'end' ? 'order-1' : 'order-2' }}">{{linkTitle}}</span>
        <div class="d-flex {{matIconPosition === 'end' ? 'order-2 ms-1' : 'order-1 me-1' }}">
          <span class="material-symbols-outlined me-1 mat-icon-size-{{matIconSize}}" [ngClass]="{'filled': matIconFilled}">{{matIcon}}</span>
        </div>
      </div>
    }
  </a>
}

@if (linkType === 'routerLink') {
  <a id="{{linkId}}" routerLink="{{linkUrl}}" title="{{linkTitle}}" [target]="linkTarget" class="btn btn-{{linkStyle}} {{linkClass}}" [queryParams]="{returnUrl : linkReturnUrl, importe: importeUrl}">
    @if (linkTitle && !matIcon) {
      <div class="d-flex align-items-center justify-content-center h-100">
        {{linkTitle}}
      </div>
    }
    @if (!linkTitle && matIcon) {
      <div class="d-flex align-items-center justify-content-center h-100">
        <span class="material-symbols-outline mat-icon-size-{{matIconSize}}" [ngClass]="{'filled': matIconFilled}">{{matIcon}}</span>
      </div>
    }
    @if (linkTitle && matIcon) {
      <div class="d-flex align-items-center justify-content-center h-100">
        <span class="{{matIconPosition === 'end' ? 'order-1' : 'order-2' }}" [innerHTML]="linkTitle"></span>
        <div class="d-flex {{matIconPosition === 'end' ? 'order-2 ms-1' : 'order-1 me-1' }}">
          <span class="material-symbols-outlined me-1 mat-icon-size-{{matIconSize}}" [ngClass]="{'filled': matIconFilled}">{{matIcon}}</span>
        </div>
      </div>
    }
  </a>
}
